module.exports = __webpack_public_path__ + "img/DE05736.0a69c2a9.png";